import React, { useState, useEffect } from "react";
import AppLayout from "@/components/AppLayout";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, Mail, Phone } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Settings() {
  const { account, logout, refresh } = useAuth();
  const [mobile, setMobile] = useState(account?.mobile_number || "");

  useEffect(() => { setMobile(account?.mobile_number || ""); }, [account]);

  const saveMobile = async () => {
    try {
      await api.patch("/accounts/mobile", { mobile_number: mobile || null });
      toast.success("Mobile updated");
      refresh();
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <AppLayout>
      <h1 className="font-display text-3xl font-bold tracking-tight">Settings</h1>
      <Card className="mt-6 p-6 border-slate-200 max-w-xl">
        <div className="text-sm text-slate-500">Account</div>
        <div className="mt-1 font-semibold">{account?.name}</div>
        <div className="text-sm text-slate-600">{account?.email}</div>

        <div className="mt-6 border-t border-slate-100 pt-6 space-y-4">
          <div>
            <div className="flex items-center gap-2 text-sm">
              <Mail className="w-4 h-4 text-slate-500" />
              <span className="text-slate-700">Email</span>
              <span className="ml-auto inline-flex items-center gap-1 text-emerald-700 text-xs">
                <CheckCircle2 className="w-4 h-4" /> Verified
              </span>
            </div>
            <div className="mt-1 text-xs text-slate-500 pl-6">Verified through Google sign-in.</div>
          </div>

          <div>
            <Label className="text-sm">
              <Phone className="inline w-4 h-4 text-slate-500 mr-1" />
              Mobile number
            </Label>
            <div className="mt-1 flex gap-2">
             <Input
  value={mobile}
  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
  placeholder="With country code, e.g. 919812345678"
  inputMode="numeric"
  pattern="[0-9]*"
  data-testid="settings-mobile"
/>
              <Button variant="outline" onClick={saveMobile} data-testid="settings-mobile-save">Save</Button>
            </div>
            <div className="mt-1 text-xs text-slate-500">
              {account?.mobile_verified
                ? "Mobile verified."
                : "SMS OTP verification will be enabled when the SMS integration is connected."}
            </div>
          </div>
        </div>

        <div className="mt-6 border-t pt-6">
          <Button variant="outline" onClick={logout} data-testid="settings-logout">Sign out</Button>
        </div>
      </Card>
    </AppLayout>
  );
}
